// extracted by mini-css-extract-plugin
module.exports = {"bg_div":"ManagePos_bg_div__2meIk","tab_bg":"ManagePos_tab_bg__3r1_v","background_div":"ManagePos_background_div__20dmC","buttonsWrapper":"ManagePos_buttonsWrapper__1QDIv"};